import React from 'react';
import { BookOpen, Droplets, Moon, Sparkles, ShoppingCart, Check } from 'lucide-react';
export function WhatsInside() {
  return <section className="py-20 bg-white" data-id="element-291">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-292">
        <div className="text-center mb-12" data-id="element-293">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-294">
            What's Inside?
          </h2>
          <p className="text-xl text-stone-600" data-id="element-295">
            This isn't just another "diet book." It is a{' '}
            <span className="font-bold text-amber-600" data-id="element-296">
              7-Day Transformation Blueprint.
            </span>
          </p>
        </div>

        {/* Curiosity Bullets */}
        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-8 md:p-10 mb-16" data-id="element-297">
          <h3 className="text-xl md:text-2xl font-bold text-stone-900 mb-6 text-center font-serif" data-id="element-298">
            In the next 7 days, you'll discover:
          </h3>
          <ul className="space-y-5 max-w-3xl mx-auto" data-id="element-299">
            <li className="flex items-start" data-id="element-300">
              <div className="flex-shrink-0 w-7 h-7 rounded-full bg-amber-500 flex items-center justify-center mt-0.5" data-id="element-301">
                <Check className="w-4 h-4 text-white" data-id="element-302" />
              </div>
              <span className="ml-4 text-lg text-stone-800" data-id="element-303">
                Why your "diet belly" is actually <strong data-id="element-304">inflammation</strong>{' '}
                (not fat)—and the 60-second test to tell the difference
              </span>
            </li>
            <li className="flex items-start" data-id="element-305">
              <div className="flex-shrink-0 w-7 h-7 rounded-full bg-amber-500 flex items-center justify-center mt-0.5" data-id="element-306">
                <Check className="w-4 h-4 text-white" data-id="element-307" />
              </div>
              <span className="ml-4 text-lg text-stone-800" data-id="element-308">
                The shocking reason <strong data-id="element-309">eating less after 45</strong> makes
                you gain <em data-id="element-310">more</em> belly fat
              </span>
            </li>
            <li className="flex items-start" data-id="element-311">
              <div className="flex-shrink-0 w-7 h-7 rounded-full bg-amber-500 flex items-center justify-center mt-0.5" data-id="element-312">
                <Check className="w-4 h-4 text-white" data-id="element-313" />
              </div>
              <span className="ml-4 text-lg text-stone-800" data-id="element-314">
                The 3 grocery store spices that act like{' '}
                <strong data-id="element-315">"nature's Ozempic"</strong> (without the $1,200/month
                price tag)
              </span>
            </li>
            <li className="flex items-start" data-id="element-316">
              <div className="flex-shrink-0 w-7 h-7 rounded-full bg-amber-500 flex items-center justify-center mt-0.5" data-id="element-317">
                <Check className="w-4 h-4 text-white" data-id="element-318" />
              </div>
              <span className="ml-4 text-lg text-stone-800" data-id="element-319">
                Why your cortisol peaks at 4 PM—and the{' '}
                <strong data-id="element-320">2-minute "reset"</strong> that stops it cold
              </span>
            </li>
          </ul>
        </div>

        {/* Chapter Cards */}
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-321">
          <div className="bg-stone-50 rounded-xl p-8 border border-stone-100 shadow-sm" data-id="element-322">
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-6" data-id="element-323">
              <Droplets className="w-6 h-6 text-amber-600" data-id="element-324" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-325">
              The "Golden Root" Tonic
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-326">
              The exact 3-ingredient recipe that shuts down systemic
              inflammation in 12 hours.
            </p>
          </div>

          <div className="bg-stone-50 rounded-xl p-8 border border-stone-100 shadow-sm" data-id="element-327">
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-6" data-id="element-328">
              <BookOpen className="w-6 h-6 text-amber-600" data-id="element-329" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-330">
              The 2-Minute Lymphatic "Flush"
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-331">
              A simple self-massage technique to drain the fluid trapped in your
              face, ankles, and belly.
            </p>
          </div>

          <div className="bg-stone-50 rounded-xl p-8 border border-stone-100 shadow-sm" data-id="element-332">
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-6" data-id="element-333">
              <Moon className="w-6 h-6 text-amber-600" data-id="element-334" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-335">
              The Cortisol Reset
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-336">
              How to signal your brain to stop storing "stress fat" while you
              sleep.
            </p>
          </div>

          <div className="bg-stone-50 rounded-xl p-8 border border-stone-100 shadow-sm" data-id="element-337">
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-6" data-id="element-338">
              <Sparkles className="w-6 h-6 text-amber-600" data-id="element-339" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-340">
              Ancestral Beauty Secrets
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-341">
              The $5 grocery store mask that firms mature skin and restores your
              natural glow.
            </p>
          </div>

          <div className="bg-stone-50 rounded-xl p-8 border border-stone-100 shadow-sm" data-id="element-342">
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-6" data-id="element-343">
              <ShoppingCart className="w-6 h-6 text-amber-600" data-id="element-344" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-345">
              The 7-Day Grocery List
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-346">
              Everything you need to "reset" your biology without breaking the
              bank.
            </p>
          </div>

          <div className="bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl p-8 text-white flex flex-col justify-center items-center text-center shadow-lg transform md:scale-105" data-id="element-347">
            <h3 className="text-2xl font-bold mb-2" data-id="element-348">Instant Access</h3>
            <p className="opacity-90" data-id="element-349">
              Start your transformation immediately after purchase.
            </p>
          </div>
        </div>
      </div>
    </section>;
}